import * as React from "react"
import type { SVGProps } from "react"
const SvgFire = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22a7.7 7.7 0 0 1-5.67-2.32A7.7 7.7 0 0 1 4 14q0-2.83 1.67-5.42a16 16 0 0 1 4.6-4.55 1 1 0 0 1 1.14-.04q.6.33.59 1.01v1.3q0 .85.59 1.43a2 2 0 0 0 2.94-.15q.2-.26.5-.32.32-.06.6.14A8 8 0 0 1 20 14q-.02 3.35-2.34 5.68A7.7 7.7 0 0 1 12 22m-6-8a6 6 0 0 0 2.03 4.5L8 18.27v-.22a3.8 3.8 0 0 1 1.18-2.78L12 12.5l2.82 2.78q.58.57.88 1.27t.3 1.5v.22q0 .1-.03.23a6.07 6.07 0 0 0 .23-8.85 4 4 0 0 1-6.17-2.9q-1.95 1.65-3 3.51A7.6 7.6 0 0 0 6 14m6 1.3-1.43 1.4a2 2 0 0 0-.57 1.35q0 .8.59 1.38T12 20t1.41-.57q.6-.59.59-1.38 0-.4-.15-.74t-.42-.61z" />
  </svg>
)
export default SvgFire
